import { render } from "./NoticeAlert.vue?vue&type=template&id=2cca4e3e&scoped=true"
import script from "./NoticeAlert.vue?vue&type=script&lang=js"
export * from "./NoticeAlert.vue?vue&type=script&lang=js"

import "./NoticeAlert.vue?vue&type=style&index=0&id=2cca4e3e&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cca4e3e"]])

export default __exports__